import { render, staticRenderFns } from "./ProductModalForm.vue?vue&type=template&id=07b44a2c"
import script from "./ProductModalForm.vue?vue&type=script&lang=js"
export * from "./ProductModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports